export default __webpack_public_path__ + "static/media/sbi.bc843781.png";